import { z } from "zod";

// Skema untuk data utama
const ReportSalesMonthlyDataV4Schema = z.object({
    month: z.string().regex(/^\d{4}-\d{2}$/, "Invalid month format, expected YYYY-MM"),
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    nb_reservations: z.number().nonnegative(),
});

// Skema untuk total per sumber (source)
const TotalSourceV4Schema = z.object({
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    nb_reservations: z.number().nonnegative(),
});

// Skema untuk total per bulan
const TotalMonthV4Schema = z.object({
    month: z.string().regex(/^\d{4}-\d{2}$/, "Invalid month format, expected YYYY-MM"),
    nb_reservations: z.number().nonnegative(),
});

// Skema utama untuk keseluruhan respons API V4
export const ReportSalesMonthlyResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(ReportSalesMonthlyDataV4Schema),
    total_source: z.array(TotalSourceV4Schema),
    total_month: z.array(TotalMonthV4Schema),
    total: z.number().nonnegative(),
});

// Ekspor tipe TypeScript
export type ReportSalesMonthlyResponseV4 = z.infer<typeof ReportSalesMonthlyResponseV4Schema>;
export type ReportSalesMonthlyDataV4 = z.infer<typeof ReportSalesMonthlyDataV4Schema>;
export type TotalSourceV4 = z.infer<typeof TotalSourceV4Schema>;
export type TotalMonthV4 = z.infer<typeof TotalMonthV4Schema>;